import React from 'react';
import { SubmenuContainer, LoadStopsInput } from '../../../forms/input_fields/loadStopsInput';
import { TaskContainer, Labels } from '../../../forms/input_fields/taskListField';
import { ActionList, ActionWithDuration } from './listOfActions'
 
export const NewOrEditTaskForm = ({tasks, _setTasks, setNewTaskAddress, taskWithDuration}) => { 
    let data = {}
    if(tasks[0].actions.length>0){
        data = {
            defaultValue : ()=>{
                try {
                    const task = tasks[0];
                    if(task){
                        task.apptDate = tasks[0].apptDate;
                        task.apptTime = tasks[0].apptTime;
                        if(taskWithDuration && !task.actions[0].apptDate){
                            task.actions[0].apptDate = tasks[0].apptDate;
                            task.actions[0].apptTime = tasks[0].apptTime;
                        }
                        return [task];
                    }
                    return null;
                } catch (error) {
                    return null;
                }
            }
        }
    }else if(taskWithDuration){        
        tasks[0].actions.push({type : "reset", endingTimeType : "Until"})
    }
    return <SubmenuContainer $topMargin={"0rem"} $bottomPadding="0.5rem">
        {
                taskWithDuration ? 
                <div id='taskWithDurationParent' style={{padding:"2rem"}}>
                    <ActionWithDuration currentTask={tasks[0]} setTasks={_setTasks}  />
                    <LoadStopsInput  column={data} editMode={false} newTaskAddressMode={true} setTaskAddress={setNewTaskAddress} noDateTime={true} initiallyInvisible={tasks[0].address ? false : true} />
                </div>
                :
            <TaskContainer className="noPadding">
                {Labels()}
                <LoadStopsInput column={data} editMode={false} newTaskAddressMode={true} setTaskAddress={setNewTaskAddress} />
                <ActionList currentTask={tasks[0]} taskIndex={0} tasks={tasks} setTasks={_setTasks} changedTasks={[]} />
            </TaskContainer>
        }
    </SubmenuContainer>
}